import React from 'react'
import './footer.css'
export default function Footer() {
  return (
    <div className='footer-container'>
        <div className="top-footer">
            <div className="footer-one">
                <img src="assets/Don-McGill-Toyota-Logo-Main.avif" alt="" />
                <p></p>
            </div>
            <div className="footer-two">
                <ul>
                    <li>About</li>
                    <li>Blog</li>
                    <li>Products</li>
                    <li>Shop</li>
                </ul>
            </div>
        </div>
        <div className="bottom-footer">
            <p>Copyright 2024 Don-McGill</p>
            <div className="payment-logo">
                <img src="assets/payoneer-removebg-preview.png" alt="" />
                <img src="assets/paypal-removebg-preview.png" alt="" />
            </div>
        </div>
    </div>
  )
}
